// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Dr","icon":"e_Er"};